export function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^|; )' + name + '=([^;]+)'))
  return match ? match[2] : null
}

export function setCookie(
  name,
  value,
  customExpire = 1000 * 60 * 60 * 24 * 365,
  domain = ''
) {
  const now = new Date()
  const time = now.getTime()
  const expireTime = time + customExpire

  now.setTime(expireTime)

  let cookie = `${name}=${value};expires=${now};path=/`

  if (domain.length > 0) {
    cookie += `;domain=${domain}`
  }

  document.cookie = cookie

  return cookie
}

export function deleteCookie(name, domain) {
  const cookie = getCookie(name)

  if (cookie) {
    const deleteCookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; Max-Age=0; path=/; ${
      domain ? `domain=${domain}` : ''
    }`
    document.cookie = deleteCookie

    return true
  }

  return false
}
